import React from "react";
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import { activityShare, isStorm } from './stock';
import bridge from '@/config/JSbridge'
import { useHistory } from 'react-router'

import MainBg from './imgs/main-bg@2x.png';
import ExplainContent from './imgs/explain-content@2x.png';

const ExplainPage = () => {
  const history = useHistory();

  const handleBack = () => {
    if (isStorm) {
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    } else {
      history.goBack();
    }
  }

  return (
    <Container>
      <Header
        title="重生之股神模拟器"
        right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
        hideNaviBar
        leftClick={handleBack}
      />
      <div className={`page-body`}>
        <div className="content-img-wrap">
          <img src={ExplainContent} alt="" className="explain-img"/>
        </div>
      </div>
    </Container>
  );
}

export default React.memo(ExplainPage);

const Container = styled.div`
  padding-top: 44px;
  .page-body {
    background-image: url(${MainBg});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .content-img-wrap {
    padding: 19px 13px 39px 8px;
  }
  .explain-img {
    width: 100%;
  }

  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_31/explain.js